/**
 * The message types the Apoteket SMS page can send, shared by the form and the route that validates
 * it.
 *
 * Kept here rather than exported from `app/api/prescription/route.ts`: a route file may only export
 * the HTTP handlers and Next's own config keys, and importing one into a client component would
 * pull the route's server-only code into the browser bundle along with it.
 *
 * The public API owns the link each type resolves to; nothing here maps them to URLs.
 */
export const MESSAGE_TYPES = ["seek_healthcare", "renew_prescription"] as const

export type MessageType = (typeof MESSAGE_TYPES)[number]

/**
 * A Swedish mobile in national form, or any number in international form.
 *
 * The same rule the public API enforces in `app-api`'s `/v1/apoteket/sms` route, repeated on both
 * sides here: the form uses it so the customer is told immediately, and `/api/prescription` uses it
 * because the form's check is a convenience and anyone can post to that route directly.
 *
 * Deliberately narrow rather than "any digits" — the number is the only free-form value the SMS
 * path accepts, and rejecting garbage here saves a pointless hop to the public API.
 */
export const MOBILE_NUMBER_PATTERN = /^(07\d{8}|\+[1-9]\d{6,14})$/

/** Spaces and dashes are how people actually type a number; strip them before matching. */
export const normaliseMobileNumber = (value: string) => value.replace(/[\s-]/g, "")
